import React from 'react';
import {
  Route,
  BrowserRouter as Router,
  Redirect,
  useHistory,
  Switch,
} from 'react-router-dom';

import ProtectedRoute from 'components/Session/ProtectedRoute';
import Login from './Login';
import Search from './Search';
import Results from './Results';

const Routes = () => {
  const history = useHistory();
  return (
    <Router
      history={history}
    >
      <Switch>
        <Route exact path="/">
          <Redirect to="/search" />
        </Route>
        <Route exact path="/login" component={Login} />

        <ProtectedRoute exact path="/search" component={Search} />
        <ProtectedRoute exact path="/results" component={Results} />
        <Redirect from="*" to="/login" />
      </Switch>
    </Router>
  );
};

export default Routes;
